var React = require('react');

function SocialYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M365.3,0H95.7C42.9,0,0,42.9,0,95.7v134.7c0,52.9,42.9,95.7,95.7,95.7h269.5c52.9,0,95.7-42.9,95.7-95.7\n\tV95.7C461,42.9,418.1,0,365.3,0z M300.5,169.7l-126.1,60.1c-3.4,1.6-7.2-0.8-7.2-4.6v-124c0-3.8,4-6.2,7.3-4.5l126.1,63.9\n\tC304.4,162.5,304.3,167.9,300.5,169.7z"}));
}

SocialYoutube.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 461 326.2","enableBackground":"new 0 0 461 326.2","xmlSpace":"preserve"};

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;
